import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface SenutoToken {
  id: string;
  token: string;
  is_active: boolean;
}

export const useSenutoToken = () => {
  const [token, setToken] = useState<SenutoToken | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchToken = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const { data, error } = await supabase
        .from('senuto_tokens')
        .select('id, token, is_active')
        .eq('is_active', true)
        .limit(1);

      if (error) {
        throw error;
      }

      // Sprawdź czy mamy dane
      if (data && data.length > 0) {
        setToken(data[0]);
      } else {
        setToken(null);
        setError('Brak aktywnego tokenu w bazie danych');
      }
    } catch (err: any) {
      console.error('Error fetching Senuto token:', err);
      setError(err.message || 'Błąd podczas pobierania tokenu');
    } finally {
      setIsLoading(false);
    }
  };

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      return false;
    }
  };


  // Automatyczne pobieranie przy pierwszym renderowaniu
  useEffect(() => {
    fetchToken();
  }, []);

  return {
    token,
    isLoading,
    error,
    fetchToken,
    copyToClipboard
  };
};
